import util from '@/util'

const mappingTabEventLabel = {
  feedback: 'Feedback',
  profile: 'Account',
  slide: 'Presentation',
}
const setPresentationAction = (context, payload) => {
  context.commit('setPresentation', payload)
}

const patchPresentationAction = (context, payload) => {
  context.commit('patchPresentation', payload)
}

const setActiveTabAction = (store, activeTab) => {
  store.commit('setActiveTab', activeTab)
  if (mappingTabEventLabel[activeTab]) {
    util.ga4Track('Main screen > Switch tab', {
      eventLabel: mappingTabEventLabel[activeTab],
    })
  }
}

export default {
  setPresentationAction,
  setPresentation: setPresentationAction,
  patchPresentationAction,
  setActiveTabAction,
}
